import { MsalProvider } from '@azure/msal-react';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { createHashRouter, createRoutesFromElements, Route, RouterProvider, BrowserRouter as Router, Navigate } from 'react-router-dom';
import { initializeMsal, msalInstance } from "./api/auth";
import { environment } from "./api/build";
import { Home } from './pages/Home';
import { AdminRoutes } from './pages/AdminRoutes';
import { AuthWrapper } from './components/AuthWrapper';
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import CheckInComponent from "./pages/Student/CheckInStudent"
import { FormPage } from './pages/Student/Onboarding/Form';
import { StudentDetailPage } from './pages/Staff/StudentDetails/StudentDetail';
import { PageNotFound } from './components/PageNotFound';
import { PageContainer } from './components/PageContainer';
import { initializeTheme, ThemeWrapper } from './components/UserTheme';

// Set a constant to control strict mode globally
const STRICT = true;

// Declare global variables for telemetry and netID
declare global {
  var telemetry: ApplicationInsights;
  var netID: string | undefined;
}

// Initialize Application Insights for telemetry
const appInsights = new ApplicationInsights({
  config: {
    // Add request context information
    addRequestContext: (ctx) => {
      return {
        environment: environment,
        netid: window.netID || "-no netid-",
      };
    },
    // Application Insights connection string and endpoints
    connectionString:
      "InstrumentationKey=8b4ad4ae-85b2-4e6d-8894-64fa20463536;IngestionEndpoint=https://eastus-8.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/;ApplicationId=95998395-2709-4c47-bd38-effe20150cdc",
  },
});

// Load Application Insights
appInsights.loadAppInsights();


initializeTheme();

const router = /* createBrowserRouter( */ createHashRouter(
  createRoutesFromElements(
    <>
      <Route path="" element={<AuthWrapper />}>
        <Route path="/Index" element={<Home/>} />
        <Route path="/onboard" element={<FormPage source='onboard' />} />
        <Route path="/admin/*" element = {<AdminRoutes />}/>
        <Route path="/checkin" element={<CheckInComponent />}/>
        <Route path="/profile/:usfid" element={<StudentDetailPage />} />
        <Route path="/profile/edit/:usfid" element={<FormPage source='edit' />} />
        <Route path="/" element={<Navigate to='/Index'/>}/>
        <Route path="*" element={<PageNotFound isNotAdminPage/>} />
      </Route>
    </>
  )
);
const container = document.getElementById('app')!;
const root = createRoot(container);

let tree = (
  <MsalProvider instance={msalInstance}>
    <ThemeWrapper>
      <PageContainer>
        <RouterProvider router={router} />
      </PageContainer>
    </ThemeWrapper>
  </MsalProvider>
);

if (STRICT && !['test', 'prod'].includes(environment)) {
  tree = (
    <React.StrictMode>
      {tree}
    </React.StrictMode>
  );
}

initializeMsal().then(() => {
  root.render(tree);
})

